var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.customClass,attrs:{"text":""},on:{"click":_vm.download}},[_c('v-icon',{attrs:{"left":_vm.text?true:false}},[_vm._v(_vm._s(_vm.icon))]),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }